import { render, staticRenderFns } from "./CollectionMap.vue?vue&type=template&id=28403b04&scoped=true"
import script from "./CollectionMap.vue?vue&type=script&lang=js"
export * from "./CollectionMap.vue?vue&type=script&lang=js"
import style0 from "./CollectionMap.vue?vue&type=style&index=0&id=28403b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28403b04",
  null
  
)

export default component.exports